import React, {useEffect, useState} from 'react'

interface FadeComponentProps {
  onFadeOutComplete: () => void
  isUnmounting: boolean
  children?: React.ReactNode
  opacityLimit?: number
}

const FadeBox: React.FC<FadeComponentProps> = ({children, onFadeOutComplete, isUnmounting, opacityLimit = 30}) => {
  const [opacity, setOpacity] = useState(0)

  useEffect(() => {
    let interval: NodeJS.Timeout

    if (!isUnmounting) {
      interval = setInterval(() => {
        setOpacity((prev) => {
          if (prev < opacityLimit / 100) {
            return prev + 0.03
          } else {
            clearInterval(interval)
            return opacityLimit / 100
          }
        })
      }, 10)
    } else {
      interval = setInterval(() => {
        setOpacity((prev) => {
          if (prev > 0) {
            return prev - 0.03
          } else {
            clearInterval(interval)
            onFadeOutComplete()
            return 0
          }
        })
      }, 10)
    }

    return () => clearInterval(interval)
  }, [isUnmounting, onFadeOutComplete])

  return (
    <div style={{width: '100%', height: '100%'}}>
      <div
        style={{
          backgroundColor: 'black',
          opacity,
          transition: 'opacity 0.1s linear',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: opacity === 0 ? 'none' : 'auto',
        }}
      />
      {opacity === opacityLimit / 100 && <div style={{position: 'absolute', zIndex: 1, top: 0, left: 0, width: '100%', height: '100%'}}>{children}</div>}
    </div>
  )
}

export default FadeBox
